var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{staticClass:"m-2 w-full border-t-1 border-outline/16"})}
var staticRenderFns = []

export { render, staticRenderFns }